import React from "react";
import { X } from "lucide-react";

export const BottomSheet = ({ open, onClose, title, children, testid }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex justify-center" data-testid={testid}>
      <div className="absolute inset-0 bg-onSurface/40 animate-in fade-in" onClick={onClose} />
      <div className="absolute bottom-0 w-full max-w-md bg-surface rounded-t-[24px] p-5 animate-slide-up max-h-[92vh] overflow-y-auto no-scrollbar" style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 20px)" }}>
        <div className="w-10 h-1 bg-borderStrong rounded-full mx-auto mb-4" />
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading text-lg font-bold text-onSurface">{title}</h3>
          <button data-testid="sheet-close" onClick={onClose} className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-surfaceTertiary"><X size={18} /></button>
        </div>
        {children}
      </div>
    </div>
  );
};
